import { updateFilterState } from '../utils/filters';
import { useFiltersStateStore } from '../internal/providers/CrmObjectTypeListingClientProvider';
import { useCallback } from 'react';
import useExpandCollapseRow from './useExpandCollapseRow';

/**
 * Returns a callback that updates the filter state.
 *
 * Updates the filter state and collapses all rows.
 */
export default function useUpdateFilters() {
  const onSetFilters = useFiltersStateStore(state => state.setFilters);
  const {
    collapseAll
  } = useExpandCollapseRow();
  const onUpdateFilters = useCallback((updatedFilter, internalOptions) => {
    onSetFilters(prevFilters => updateFilterState(prevFilters, updatedFilter), internalOptions);
    collapseAll();
  }, [collapseAll, onSetFilters]);
  return {
    onUpdateFilters
  };
}